if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) { 
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage(); 
        this.error = false;

        // --- INÍCIO: Validação de Restrição de Carrinho ---
        this.RESTRICTED_TYPES = ['Material', 'Uniforme'];
        this.RESTRICTION_ERROR_MESSAGE = '<h4>Você só pode comprar um tipo de benefício por vez: Uniforme ou Material Escolar</h4><p>Finalize a compra atual ou remova os itens do carrinho para comprar este produto.</p>';
        const productTypeToAdd = this.submitButton.getAttribute('data-product-type');

        if (productTypeToAdd && this.RESTRICTED_TYPES.includes(productTypeToAdd)) {
          this.submitButton.setAttribute('aria-disabled', true);
          this.submitButton.classList.add('loading');
          if(this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.remove('hidden');

          try {
            const cartResponse = await fetch('/cart.js');
            if (!cartResponse.ok) throw new Error('Falha ao buscar carrinho');
            const cart = await cartResponse.json();

            let existingRestrictedType = null;
            if (cart.item_count > 0) {
              for (const item of cart.items) {
                if (item.properties && item.properties._product_type && this.RESTRICTED_TYPES.includes(item.properties._product_type)) {
                  existingRestrictedType = item.properties._product_type;
                  break;
                }
              }
            }

            if (existingRestrictedType && existingRestrictedType !== productTypeToAdd) {
              this.handleMultiCategoryErrorMessage(this.RESTRICTION_ERROR_MESSAGE);
              this.error = true;
              this.submitButton.classList.remove('loading');
              this.submitButton.removeAttribute('aria-disabled');
              if(this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
              console.warn('Adição ao carrinho bloqueada: tipos conflitantes.');
              return;
            }

          } catch (error) {
            console.error('Erro ao validar restrição do carrinho:', error);
            this.handleErrorMessage('Erro ao verificar o carrinho. Tente novamente.');
            this.error = true;
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            if(this.querySelector('.loading__spinner')) this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }
        }
        // --- FIM: Validação de Restrição de Carrinho ---

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled'); 
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      handleMultiCategoryErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMultiCategoryMessageWrapper =
          this.errorMultiCategoryMessageWrapper || this.querySelector('.product-multi-category__error-message-wrapper');
        if (!this.errorMultiCategoryMessageWrapper) return;
        this.errorMessage = this.errorMultiCategoryMessageWrapper.querySelector('.product-multi-category__error-message');

        this.errorMultiCategoryMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.innerHTML = errorMessage;
        }

        this.errorMultiCategoryMessageWrapper.querySelector('.alert__multi-category-close').addEventListener('click', () => {
          this.errorMultiCategoryMessageWrapper.toggleAttribute('hidden', true);
        });
      }
      
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
